import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API || 'http://localhost:5000/api';

export default function StudentDashboard() {
  const [profile, setProfile] = useState(null);
  const [edit, setEdit] = useState({
    name: '',
    email: '',
    roll_number: '',
    course: '',
    extra: ''
  });

  const token = localStorage.getItem('token');

  // ✅ useCallback so fetchProfile can be used in useEffect without warnings
  const fetchProfile = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/students/me/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProfile(res.data);
      setEdit({
        name: res.data.name || '',
        email: res.data.email || '',
        roll_number: res.data.roll_number || '',
        course: res.data.course || '',
        extra: res.data.extra || ''
      });
    } catch (err) {
      console.error(err);
    }
  }, [token]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  async function save(e) {
    e.preventDefault();
    try {
      await axios.put(`${API}/students/me/profile`, edit, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProfile(); // refresh after save
      alert('Saved');
    } catch (err) {
      console.error(err);
    }
  }

  if (!profile) return <div>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Student Dashboard</h2>
      <form onSubmit={save}>
        <div>
          <label>Name</label>
          <input
            value={edit.name}
            onChange={(e) => setEdit({ ...edit, name: e.target.value })}
          />
        </div>
        <div>
          <label>Email</label>
          <input
            value={edit.email}
            onChange={(e) => setEdit({ ...edit, email: e.target.value })}
          />
        </div>
        <div>
          <label>Roll Number</label>
          <input
            value={edit.roll_number}
            onChange={(e) => setEdit({ ...edit, roll_number: e.target.value })}
          />
        </div>
        <div>
          <label>Course</label>
          <input
            value={edit.course}
            onChange={(e) => setEdit({ ...edit, course: e.target.value })}
          />
        </div>
        <div>
          <label>Extra</label>
          <input
            value={edit.extra}
            onChange={(e) => setEdit({ ...edit, extra: e.target.value })}
          />
        </div>
        <button type="submit">Save</button>
      </form>

      <h3>Profile</h3>
      <pre>{JSON.stringify(profile, null, 2)}</pre>
    </div>
  );
}
